import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Button, Paper, TextField, Autocomplete, Box, Stack } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, LabelList } from 'recharts';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { useGetOutletComboMutation, useGetLaunchingComboMutation, useGetSaleReportsMutation } from '../../services/reports';
import { useGetOutletsMutation } from '../../services/replenishmentSystem';
import LoadingPage from '../loadingPage';
import AlertSnackbar from '../alertSnackbar';
import "react-day-picker/style.css";
import moment from 'moment';
import XLSX from 'xlsx-js-style';//import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import DateRange from '../tools/daterange';
import CustomTable from '../tools/customTable';
const API_URI = process.env.REACT_APP_API_URI;

export default function SalesReports() {
  const [getOutlets, outletsResult] = useGetOutletsMutation();
  const [getLaunchingCombo, launchingResult] = useGetLaunchingComboMutation();
  const [getSaleReports, saleReportsResult] = useGetSaleReportsMutation();
  const [dataLoaded, setDataLoaded] = useState([]);
  const [dataTotal, setDataTotal] = useState({});
  const [columns, setColumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);
  const [snackContent, setSnackContent] = useState("");
  const [range, setRange] = useState({from: moment().startOf('month'), to: moment()});
  const [viewDetail, setViewDetail] = useState(0);
  const [outlets, setOutlets] = useState([]);
  const [lstLaunching, setLstLaunching] = useState([]);
  const [reportType, setReportType] = useState(null);
  const [selectedStore, setSelectedStore] = useState({});
  const [userId, setUserId] = useState(0);
  const [openImport, setOpenImport] = useState(false);
  const [uniqueStores, setUniqueStores] = useState([]);
  const gridRef = useRef();
  const [pinnedBottomRowData, setPinnedBottomRowData] = useState([
      { make: 'Total', model: '', TOTAL: 0 }
  ]);
  
  ModuleRegistry.registerModules([ AllCommunityModule ]);
	const user = JSON.parse(window.localStorage.getItem('user'));

  useEffect(() => {
    handleGridHeight();
    getOutlets({"UserId": user.id});

    const uId = JSON.parse(window.localStorage.getItem("user"))?.id;
    setUserId(uId);

    window.addEventListener("resize", handleGridHeight);
    return () => {
      window.removeEventListener("resize", handleGridHeight);
    };
  }, []);

  const handleGridHeight = () =>{
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?.clientHeight || 0) - 66);
  }

  useEffect(() => {
    if(saleReportsResult.data)
    {
      const dt = JSON.parse(saleReportsResult.data);
      let totalOnPrice = 0, totalOnRSP = 0;
			if(reportType == "SellThruPerStore" || reportType == "StoreSellingRate" || reportType == "MidYearSellThruPerStore" || reportType == "MidYearStoreSellingRate"){
				const formattedData = Object.values(
					dt.reduce((acc, row) => {
						if (!acc[row.InvDate]) {
							acc[row.InvDate] = { InvDate: row.InvDate };
						}
						// Assign the TotalQty value to the specific Store's key
						acc[row.InvDate][row.StoreName] = row.TotalQty;
            const discOnPrice = (row.TotalOnRSP||0) == 0 ? 0 : (100.0 - ((row.TotalOnPrice || 0) / (row.TotalOnRSP || 1) * 100.0).toFixed(2)).toFixed(2);
            acc[row.InvDate]['TotalOnPrice'] = (acc[row.InvDate]['TotalOnPrice'] || 0) + (row.TotalOnPrice || 0);
            acc[row.InvDate]['TotalOnRSP'] = (acc[row.InvDate]['TotalOnRSP'] || 0) + (row.TotalOnRSP || 0);
            acc[row.InvDate]['DiscountOnPrice'] = {...acc[row.InvDate]['DiscountOnPrice'], [`${row.StoreName}`]: discOnPrice};
						totalOnPrice += (row.TotalOnPrice || 0);
            totalOnRSP += (row.TotalOnRSP || 0);
            return acc;
					}, {})
				);
				setDataLoaded(formattedData);
        setDataTotal({DiscOnPrice: (totalOnRSP||0) == 0 ? 0 : (100.0 - ((totalOnPrice || 0) / (totalOnRSP || 1) * 100.0).toFixed(2)).toFixed(2) });

				const uniqueSto = [...new Set(dt.map(row => row.StoreName))];
				setUniqueStores(uniqueSto);
			}
			else
				setDataLoaded(dt);
      // if(dt.length > 0)
      //   getCoumns(dt[0]);
      // updatePinnedBottomRow(null, dt);
    }
  }, [saleReportsResult]);

	const getColor = (index) => {
    const colors = [
		'#0047AB', '#00FF00', '#FF9500', '#FF007F', '#00FFFF', '#FF00FF', 
    '#4B0082', '#00A86B', '#8F00FF', '#FFCC00', '#0F52BA', 
    '#DC143C', '#8E4585', '#CC5500', '#008080', '#E0115F', 
    '#40E0D0', '#36454F', '#228B22', '#DE5D83', '#007BA7', 
    '#FFBF00', '#9966CC', '#F28500', '#000080', '#FC8EAC', '#50C878', 
    '#C04000', '#DA70D6', '#B7410E', '#800020', '#E2725B', '#CD7F32', 
    '#704214', '#0A0A0A', '#708090', '#C0C0C0', '#808000', '#9C9F84', 
    '#FA8072', '#D2B48C', '#87CEEB', '#C3B091', '#8F00FF', '#007AFF', 
    '#4CD964', '#AF52DE', '#FF2400', '#7FFF00', '#FF7F50'];

    return colors[index % colors.length];
  };

  useEffect(() => {
		if(outletsResult && outletsResult.data){
      loadOutletOptions(reportType);
    }
  }, [outletsResult]);

  const loadOutletOptions=(rpType)=>{
    let st = [];
    if(rpType == 'StoreSellingRate'){
      st.push({value: 'D2C', label: 'D2C'});
      st.push({value: 'Ecom', label: 'Ecom'});
      st.push({value: 'B2B', label: 'B2B'});
      st.push({value: 'All', label: 'All Channels'});
    }
    outletsResult.data.map(m=>{
      if(m.name != 'All' || selectedStore != 'StoreSellingRate')
        st.push({value: m.value, label: m.name.replace('All', 'D2C').replace('South1', 'D2C South1').replace('South2', 'D2C South2')});
    })
    setOutlets(st);
  }

  const getDataView=()=>{
    if(!reportType) {setSnackContent("Vui lòng chọn loại report"); return;}
    if(!range) return;

    getSaleReports({"ReportID": reportType, "Code": selectedStore.value||0
        , "FromDate": moment(range.from).format('DD-MM-YYYY') , "ToDate": moment(range.to).format('DD-MM-YYYY')
    });
    // handleGridHeight();
    // gridRef.current.setFilterModel(null);
  }

  const onChangeReportType=(record)=>{
    setReportType(record.value);
    loadOutletOptions(record.value);
    setDataLoaded([]);
  }

  const onChangeStore=(record)=>{
    setSelectedStore(record);
    setDataLoaded([]);
  }

  const getCoumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        filter: true,
        headerName: key.replace('__', '/ '),
        width: key=="Description"?280:key=="LaunchMonth"?150:(key.length>12?200:120),
        cellStyle: () => ((key=="Order" || key=="D2C" || key=="Ecom" || key=="B2B" || key=="SOH_D2C" || key=="SOH_DC" || key=="SOH_VN")
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
          fontWeight: key=="TotalNet" ? "bold" : ""
        }:null),
        // valueFormatter: params => params.data[key] && (
        //   (key=="FirstSellingDate")?moment(params.data[key]).format("YYYY-MM-DD")
        //   :(key=="Order" || key=="D2C" || key=="ECOM" || key=="B2B")?new Intl.NumberFormat('en-US').format(params.data[key]):params.data[key]
        // ),
        hide: (key=="SalesN"||key=="SalesC"||key=="SalesS"||key=="SalesSW"||key=="StockN"||key=="StockC"||key=="StockS"||key=="StockSW"
          ||((selectedStore.value||0) != 0 && (key=="Input__Order"||key=="HaveSellout__HaveStock"||key=="D2C__SOH"))?true:false),
        cellRenderer: (props) => CustomCell(props, key)
      }
    });
    setColumns(cols);
  }

  const CustomCell = (props, key) => {
    if(key=="FirstSellingDate")
      return props.value?moment(props.value).format("DD/MM/YYYY"):'';
    else if(key=="Order" || key=="D2C" || key=="Ecom" || key=="B2B")
      return new Intl.NumberFormat('en-US').format(props.value);
    else return props.value;
  };

  const onGridReady = useCallback((params) => {
    gridRef.current = params.api;
    updatePinnedBottomRow(params.api); // Initial calculation
  }, []);

  const updatePinnedBottomRow = (api, data) => {
    let D2C = 0, Ecom = 0, B2B = 0;
    if(data)
      data.map(m=>{
        const d2c_soh = m.D2C__SOH.split('/');
        D2C += parseInt(d2c_soh[0].trim()||0);
        Ecom += m.Ecom;
        B2B += m.B2B;
      })
    else
      api.forEachNodeAfterFilter((node) => {
        const d2c_soh = node.data.D2C__SOH.split('/');
        D2C += parseInt(d2c_soh[0].trim()||0);
        Ecom += node.data.Ecom;
        B2B += node.data.B2B;
      });
    setPinnedBottomRowData([{ make: 'Total', model: '', D2C: D2C, Ecom: Ecom, B2B: B2B}]);
  };

  const onFilterChanged = useCallback(() => {
    if (gridRef.current) {
        updatePinnedBottomRow(gridRef.current);
    }
  }, []);

  const getRowClass = useCallback(params => {
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    wrapperBorder: false,
    headerRowBorder: false,
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  const renderCustomDot = (props) => {
		const { cx, cy, payload } = props;

		// Change color based on your data property
		const ddd = moment(payload.InvDate).format('ddd');
		const dotColor = (ddd == 'Fri' || ddd == 'Sat' || ddd == 'Sun') ? '#FF0000' : '#8884d8'; 

		return (
		<circle 
				cx={cx} 
				cy={cy} 
				r={5} 
				fill={dotColor} 
				stroke="none" 
		/>
		);
	};

  const CustomTooltip = ({ active, payload, label }) => {
    // Only render if the user is hovering over a data point
    if (active && payload && payload.length) {
      // The raw data object for this specific row is stored inside payload[0].payload
      const rowData = payload[0].payload; 
      return (
        <div style={{
          backgroundColor: '#fff',
          padding: '10px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.15)'
        }}>
          <p style={{ margin: '0 0 5px', fontWeight: 'bold' }}>{`Date: ${moment(label).format('DD/MM/YYYY')}`}</p>
          
          {payload.map((item, idx) => {
            const storeName = item.name;
            const salesValue = item.value;
            // Extract the nested discount value using the line's name/key
            const discount = rowData.DiscountOnPrice?.[storeName];

            return (
              <div key={idx} style={{ color: item.color, margin: '3px 0' }}>
                <span>{storeName}: </span>
                <strong>{salesValue} items</strong>
                {discount !== undefined && (
                  <span style={{ color: '#ff4d4f', marginLeft: '8px' }}>
                    (Disc: {discount} %)
                  </span>
                )}
              </div>
            );
          })}
        </div>
      );
    }

    return null;
  };

  const formatXAxisTick = (tickValue) => {
    // Clean up the date string if it contains timestamps (e.g., '2026-08-01T00:00:00')
    const displayDate = `${moment(tickValue).format('DD')}`;//tickValue.split('T')[0];

    // Find the original data row matching this specific tick date
    const row = dataLoaded.find(item => item.InvDate === tickValue);
    const discOnPrice = (row.TotalOnRSP||0) == 0 ? 0 : (100.0 - ((row.TotalOnPrice || 0) / (row.TotalOnRSP || 1) * 100.0).toFixed(2)).toFixed(2);
    if (row && row.TotalOnRSP) {
      const discOnPrice = (row.TotalOnRSP||0) == 0 ? 0 : (100.0 - ((row.TotalOnPrice || 0) / (row.TotalOnRSP || 1) * 100.0).toFixed(2)).toFixed(2);
      const discountValues = Object.values(discOnPrice);
      return `${displayDate} (${discOnPrice} %)`;
    }
    
    return displayDate;
  };

  return (
    <div style={{padding: '0 10px'}}>
      { (saleReportsResult.isLoading) && <LoadingPage /> }
      <div style={{marginTop: '10px'}}>
        <Box id='divHeader' sx={{ width: '100%' }}>
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            sx={{
              overflowX: 'auto', pt: 1, mb: 0.5,
              pb: 0.5, // Space for the scrollbar so it doesn't touch the buttons
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#ccc',
                borderRadius: '10px',
              },
              // Ensure items don't shrink and stay on one line
              flexWrap: 'nowrap',
            }}
          >
            <Autocomplete disablePortal size="small"
              options={[{value: 'MidYearSellThruPerStore', label: 'Mid Year Sell Thru per store'}, {value: 'MidYearStoreSellingRate', label: 'Mid Year Store Selling Rate'}, {value: 'SellThruPerStore', label: 'Sell Thru per store'}, {value: 'StoreSellingRate', label: 'Store Selling Rate'}]}
              sx={{ flexShrink: 0, width: 250 }}
              onChange={(e, item)=>onChangeReportType(item)}
              renderInput={(params) => <TextField {...params} label="Select report" />}
              disableClearable
            />
            <Box sx={{ flexShrink: 0 }}>
              <DateRange range={range} setRange={setRange} />
            </Box>
						
            <Autocomplete disablePortal size="small"
              options={outlets}
              sx={{ flexShrink: 0, width: 350 }}
              onChange={(e, item)=>onChangeStore(item)}
              renderInput={(params) => <TextField {...params} label="Store" />}
              loading={outletsResult.isLoading}
              disableClearable
            />

            <Button variant="contained" onClick={getDataView}
              sx={{ flexShrink: 0 }}>View</Button>
          </Stack>
        </Box>
        {reportType==''?
        <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
          <AgGridReact enableCellTextSelection={true} ensureDomOrder={true}
            rowData={dataLoaded}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={500}
            paginationPageSizeSelector={[200, 500, 1000]}
            pinnedBottomRowData={pinnedBottomRowData}
            getRowClass={getRowClass}
            theme={theme}
            onGridReady={onGridReady}
            onFilterChanged={onFilterChanged}
          />
        </Paper>
        :<Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
            {reportType == 'StoreSellingRate' && dataTotal.DiscOnPrice?
              <span style={{position: 'absolute', right: '50px', marginTop: '8px'}}>{moment(range.from).format('DD-MM-YYYY')} - {moment(range.to).format('DD-MM-YYYY')}: {dataTotal.DiscOnPrice} %</span>:''}
            <ResponsiveContainer>
            <LineChart
                data={dataLoaded?dataLoaded:[]}
                margin={{ top: 5, right: 30, left: 30, bottom: 5 }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                {/* <XAxis tickFormatter={(value) => `${moment(value).format('DD')}`} dataKey="InvDate" hide={false} /> */}
                <XAxis 
                  dataKey="InvDate" 
                  tickFormatter={formatXAxisTick} 
                  height={50}
                  tick={{ fill: '#555', fontSize: 11 }}
                />
                <YAxis tickFormatter={(value) => `${value.toLocaleString()}${reportType=="SellThruPerStore"||reportType=="MidYearSellThruPerStore"?" %":""}`} />
                {/* <Tooltip 
									labelFormatter={(label) => `Date: ${moment(label).format('DD/MM/YYYY')}`}
									itemSorter={(item) => -item.value}
									formatter={(value, name) => [`${value}${reportType=="SellThruPerStore"||reportType=="MidYearSellThruPerStore"?" %":""}`
                    , reportType=="StoreSellingRate"||reportType=="MidYearStoreSellingRate"?name.replace("1.","").replace("2.","").replace("3.",""):name]}
                /> */}
                <Tooltip content={<CustomTooltip />} />
                <Legend />
								{uniqueStores.map((store, index1) => (
									<Line key={store} type="monotone"
										dataKey={store} name={store}
										stroke={getColor(index1)} strokeWidth={3}
										dot={renderCustomDot} activeDot={{ r: 8 }}
                    label={(props) => {
                      if(reportType == "StoreSellingRate"){
                        const { x, y, value, index } = props;
                        const discountValue = dataLoaded[index]?.DiscountOnPrice?.[`${store}`];
                        return (
                          <text x={x} y={y} dy={-10} fill="#8884d8" fontSize={12} textAnchor="middle">
                            {discountValue} %
                          </text>
                        );
                      }
                      else
                        return '';
                    }} 
										// connectNulls    // Prevents lines from breaking if a store skips a date
									/>
								))}
                {/* <Line type="monotone" dataKey="TotalGross" stroke="#8884d8" strokeWidth={5} dot={renderCustomDot} />
                <Line type="monotone" dataKey="TotalNet" stroke="#0092388b" strokeWidth={5} dot={renderCustomDot}>
                	<LabelList dataKey="InvDate" position="bottom" fill='blue' style={{zIndex: 1000}}
                    formatter={(value) => `${moment(value).format('DD')}`} />
                </Line> */}
            </LineChart>
            </ResponsiveContainer>
        </Paper>
        }
      </div>

      <AlertSnackbar message={snackContent} setSnackContent={setSnackContent}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} />
    </div>
  )
}